import ManualDiscountTable from './ManualDiscountTable'

export default ManualDiscountTable
